import React from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'

import {
  ActionSlot,
  BackButton,
  TabBadge,
  TabBar,
  TabButton,
  TabIcon,
  TabLabel,
  TopBar,
  TopBarBeta,
  TopBarTitle,
} from './mobile-styled'
import { itemTarget, pickTabItems, resolveMobileView } from './mobile-shell'

// Верхняя панель: назад (на вложенных страницах), название раздела и справа
// место для главной кнопки страницы. Кнопку страницы кладёт туда сама
// страница через <Button pageAction> - см. components/button
export const MobileTopBar = ({ navItems, actionSlotRef }) => {
  const { pathname, state } = useLocation()
  const navigate = useNavigate()
  const { title, beta, isDetail, item } = resolveMobileView(pathname, navItems)

  const goBack = () => {
    // Страницы сами знают, откуда пришли (state.backpath), история браузера
    // - запасной путь
    if (state?.backpath) navigate(state.backpath)
    else if (window.history.length > 1) navigate(-1)
    else if (item) navigate(itemTarget(item))
  }

  return (
    <TopBar>
      {isDetail && (
        <BackButton type="button" aria-label="Назад" onClick={goBack}>
          <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
        </BackButton>
      )}
      <TopBarTitle>
        {title}
        {beta && <TopBarBeta>бета</TopBarBeta>}
      </TopBarTitle>
      <ActionSlot ref={actionSlotRef} />
    </TopBar>
  )
}

// Нижняя панель: «Главная» (меню на весь экран) и четыре раздела, которые
// доступны этой роли и нужны чаще остальных
export const MobileTabBar = ({ navItems, menuOpen, onToggleMenu }) => {
  const { pathname } = useLocation()
  const { item: current } = resolveMobileView(pathname, navItems)
  const tabs = pickTabItems(navItems)
  const hiddenAttention = navItems.some((item) => item.badgeDot && !tabs.includes(item))

  return (
    <TabBar aria-label="Основная навигация">
      <TabButton type="button" className={menuOpen ? 'active' : ''} onClick={onToggleMenu}>
        <TabIcon className={menuOpen ? 'active' : ''}>
          <HomeOutlinedIcon sx={{ fontSize: 22 }} />
          {hiddenAttention && !menuOpen && <TabBadge />}
        </TabIcon>
        <TabLabel>Главная</TabLabel>
      </TabButton>
      {tabs.map((item) => {
        const target = itemTarget(item)
        const active = !menuOpen && current === item
        return (
          <TabButton
            key={item.title}
            as={NavLink}
            to={{ ...target }}
            className={active ? 'active' : ''}
          >
            <TabIcon className={active ? 'active' : ''}>
              {item.icon}
              {item.badgeDot && <TabBadge />}
            </TabIcon>
            <TabLabel>{item.title}</TabLabel>
          </TabButton>
        )
      })}
    </TabBar>
  )
}
